type UnknownRecord = Record<string, unknown>;

function asRecord(value: unknown): UnknownRecord | null {
  return value && typeof value === 'object' ? (value as UnknownRecord) : null;
}

function asString(value: unknown): string | undefined {
  return typeof value === 'string' ? value : undefined;
}

function asStatus(value: unknown): string | number | undefined {
  return typeof value === 'string' || typeof value === 'number' ? value : undefined;
}

export function getSafeErrorDetails(error: unknown): UnknownRecord {
  const record = asRecord(error);

  if (!record) {
    return { type: typeof error };
  }

  const response = asRecord(record['response']);

  return {
    name: asString(record['name']),
    code: asString(record['code']),
    status:
      asStatus(record['status']) ??
      asStatus(record['statusCode']) ??
      asStatus(response?.['status']),
    hasMessage: typeof record['message'] === 'string' && record['message'].length > 0
  };
}

export function getSafeAuthResultDetails(result: unknown): UnknownRecord {
  const record = asRecord(result);

  if (!record) {
    return { type: typeof result };
  }

  const codeDelivery = asRecord(record['codeDeliveryDetails']);
  const challengeParam = asRecord(record['challengeParam']);
  const challengeAttributes = asRecord(challengeParam?.['userAttributes']);

  return {
    challengeName: asString(record['challengeName']),
    authenticationFlowType: asString(record['authenticationFlowType']),
    hasSession: Boolean(record['signInUserSession']),
    userConfirmed:
      typeof record['userConfirmed'] === 'boolean' ? record['userConfirmed'] : undefined,
    deliveryMedium: asString(codeDelivery?.['DeliveryMedium']),
    hasDeliveryDestination: typeof codeDelivery?.['Destination'] === 'string',
    hasChallengeAttributes: Boolean(challengeAttributes)
  };
}
